import React from 'react';
import Prayers from '../components/Prayers';
import Novenas from '../components/Novenas';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const PrayersPage = () => {
   const [isContactModalOpen, setIsContactModalOpen] = React.useState(false);
      const openContactModal = () => setIsContactModalOpen(true);
    const closeContactModal = () => setIsContactModalOpen(false);
  return (
    <div className="prayers-page min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header openContactModal={openContactModal} />
         {/* Modal de contact */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal} 
      />
      {/* En-tête de la page */}
      <div className="bg-gradient-to-r from-fsf-primary to-fsf-secondary py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Prières & Neuvaines
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto text-justify">
            Nourrissez votre vie spirituelle avec nos collections de prières pour couples mariés 
            et nos neuvaines spécialement adaptées à notre communauté béninoise.
          </p>
        </div>
      </div>
      
      {/* Section Prières */}
      <section id="prieres" className="py-8">
        <Prayers />
      </section>
      
      {/* Section Neuvaines */}
      <section id="neuvaines" className="py-8">
        <Novenas />
      </section>
      <Footer />
    </div>
  );
};

export default PrayersPage;